import { writable, readable } from 'svelte/store';
import { _api_host, _bam_domain } from './constants.js';


export const menu_items_global = [
    ['Home', '/home'],
    ['Jobs', '/jobs'],
    ['Contact Us', '/contact'],
    ['Log In', '/login']
];
export const menu_items_auth = [
    ['Book a Service', '/book_service'],
    ['Referrals', '/referral'],
    ['Jobs', '/jobs'],
    ['My Profile', '/profile'],
    ['Log Out', '/logout']
];

export const selected_menu_item = writable(0);

export const toast_options =  writable({
});

export const company_info = readable({
    name: "Company Name",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    email: "",
    phone: "",
});

export const bpm_header = writable({});
export const bpm_main = writable({});
export const bpm_footer = writable({});

export const user_store = writable({is_authenticated: false});
export const company_details_store = writable({});
export const business_hours_store = writable({});
export const user_info_store = writable({});
export const price_settings_store = writable({});
export const domain_code_store = writable('');
export const avatar_store = writable('');
export const places_store = writable({});
export const site_activate_store = writable(false);
export const plan_type_store = writable('');
export const all_jobs_store = writable([]);
export const page_setting_store = writable({});

export const sitekey = '6LczIjMgAAAAAA7Iat2xKfRAz7HLG5cHI-lno56y';

///////////////// TODO: DISABLE FOR PRODUCTION
export const redirect_uri = readable("https://app.houseofyards.com");
export const cms_host = readable("https://cms.staging.houseofyards.com");

export const api_host = _api_host;
export const bam_domain = readable(_bam_domain);